export enum ABTests {
  WISHLIST_REVAMP_ENABLED = 'spxPepeWishlistRevampWeb',
}
